import { post, put } from './requests'

const resourcePath = 'api_key'

export function createApiKey () {
  return post(resourcePath)
}

export function deactivateApiKey () {
  return put(`${resourcePath}/deactivate`)
}

export function activateApiKey () {
  return put(`${resourcePath}/activate`)
}

export function resetApiKey () {
  return put(`${resourcePath}/reset`)
}
